import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowController extends Controller {}
